export const mixins = {
  toolbar: { height: 51 },
  paddingRadioCheckbox: '6px 9px',
}
